(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uniq-team"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const carouselContainer = document.querySelector('[data-uniq-team-carousel-container]');
    if (!carouselContainer) return;

    const carousel = document.querySelector('[data-uniq-team-carousel]');
    const prevButton = document.querySelector('[data-uniq-team-prev-button]');
    const nextButton = document.querySelector('[data-uniq-team-next-button]');
    const paginationDots = document.querySelectorAll('[data-uniq-team-pagination-dot]');
    const teamMembers = document.querySelectorAll('[data-uniq-team-member]');

    // Set the number of items to show based on screen width
    let itemsToShow = 5;
    const updateItemsToShow = () => {
        if (window.innerWidth <= 600) {
            itemsToShow = 1;
        } else if (window.innerWidth <= 900) {
            itemsToShow = 2;
        } else if (window.innerWidth <= 1200) {
            itemsToShow = 3;
        } else {
            itemsToShow = 5;
        }
    };

    // Lazy loading function for team members
    const lazyLoadTeamMembers = () => {
        // Make visible ones non-lazy
        teamMembers.forEach((member, index) => {
            if (index >= currentIndex && index < currentIndex + itemsToShow) {
                member.classList.remove('uniq-team-member--lazy');
                const lazyImages = member.querySelectorAll('img[loading="lazy"]');
                lazyImages.forEach(img => {
                    img.setAttribute('loading', 'eager');
                });
            }
        });
    };

    // Initial update
    updateItemsToShow();

    // Update on window resize
    window.addEventListener('resize', () => {
        updateItemsToShow();
        lazyLoadTeamMembers();
    });

    const totalItems = teamMembers.length;
    let currentIndex = 0;

    // Function to update carousel position
    const updateCarouselPosition = () => {
        // Only proceed if we have team members
        if (!teamMembers.length) return;

        // Recalculate itemsToShow to make sure it's correct
        updateItemsToShow();

        // FIX: Calculate actual gap size based on CSS
        // Get the computed style from the carousel element
        const carouselStyle = window.getComputedStyle(carousel);
        const gapSize = parseInt(carouselStyle.gap) || 20; // Default to 20 if not set

        const itemWidth = teamMembers[0].offsetWidth;
        // Add the actual gap size, not a hardcoded value
        const slideDistance = itemWidth + gapSize;
        
        carousel.style.transform = `translateX(-${currentIndex * slideDistance}px)`;

        // Lazy load members that will be visible
        lazyLoadTeamMembers();

        // Update pagination dots if they exist
        if (paginationDots.length) {
            paginationDots.forEach((dot, index) => {
                dot.classList.toggle('uniq-team-active', index === currentIndex);
                // Update ARIA attributes for accessibility
                dot.setAttribute('aria-selected', index === currentIndex ? 'true' : 'false');
            });
        }

        // Update button states if they exist
        if (prevButton && nextButton) {
            prevButton.disabled = currentIndex === 0;
            prevButton.style.opacity = currentIndex === 0 ? '0.5' : '1';
            prevButton.setAttribute('aria-disabled', currentIndex === 0 ? 'true' : 'false');

            // FIX: Ensure correct calculation for mobile
            const maxIndex = totalItems - itemsToShow;
            nextButton.disabled = currentIndex >= maxIndex;
            nextButton.style.opacity = currentIndex >= maxIndex ? '0.5' : '1';
            nextButton.setAttribute('aria-disabled', currentIndex >= maxIndex ? 'true' : 'false');
        }

        // Announce for screen readers
        const liveRegion = document.createElement('div');
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.classList.add('visually-hidden');
        liveRegion.innerText = `Showing team members ${currentIndex + 1} to ${Math.min(currentIndex + itemsToShow, totalItems)} of ${totalItems}`;
        carouselContainer.appendChild(liveRegion);

        setTimeout(() => {
            liveRegion.remove();
        }, 1000);
    };

    // Click events for navigation buttons
    if (prevButton) {
        prevButton.addEventListener('click', () => {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarouselPosition();
            }
        });
    }

    if (nextButton) {
        nextButton.addEventListener('click', () => {
            if (currentIndex < totalItems - itemsToShow) {
                currentIndex++;
                updateCarouselPosition();
            }
        });
    }

    // Click events for pagination dots
    if (paginationDots.length) {
        paginationDots.forEach((dot) => {
            dot.addEventListener('click', () => {
                const dotIndex = parseInt(dot.getAttribute('data-index'), 10);
                // Ensure we don't go beyond the maximum scrollable position
                currentIndex = Math.min(dotIndex, totalItems - itemsToShow);
                updateCarouselPosition();
            });

            // Keyboard support for pagination dots
            dot.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    dot.click();
                }
            });
        });
    }

    // Set initial button states
    updateCarouselPosition();

    // Add keyboard navigation for accessibility
    document.addEventListener('keydown', (e) => {
        if (document.activeElement.closest('[data-uniq-team-section]')) {
            if (e.key === 'ArrowLeft') {
                if (currentIndex > 0) {
                    currentIndex--;
                    updateCarouselPosition();
                }
            } else if (e.key === 'ArrowRight') {
                if (currentIndex < totalItems - itemsToShow) {
                    currentIndex++;
                    updateCarouselPosition();
                }
            }
        }
    });

    // Handle touch events for mobile swipe with improved touch targets
    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, {
        passive: true
    });

    carousel.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, {
        passive: true
    });

    const handleSwipe = () => {
        const swipeThreshold = 50;
        if (touchEndX < touchStartX - swipeThreshold) {
            // Swipe left
            if (currentIndex < totalItems - itemsToShow) {
                currentIndex++;
                updateCarouselPosition();
            }
        } else if (touchEndX > touchStartX + swipeThreshold) {
            // Swipe right
            if (currentIndex > 0) {
                currentIndex--;
                updateCarouselPosition();
            }
        }
    };

    // Initialize first batch of team members as non-lazy
    teamMembers.forEach((member, index) => {
        if (index < itemsToShow) {
            member.classList.remove('uniq-team-member--lazy');
        }
    });

    // Set up a resize observer to handle orientation changes on mobile
    const resizeObserver = new ResizeObserver(() => {
        updateItemsToShow();
        updateCarouselPosition();
    });

    resizeObserver.observe(carouselContainer);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uniq-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('[data-uniq-testimonial-carousel-container]');
    if (!container) return;

    const track = container.querySelector('[data-uniq-testimonial-carousel]');
    const cards = container.querySelectorAll('[data-uniq-testimonial-card]');
    const btnPrev = container.querySelector('[data-uniq-testimonial-prev-button]');
    const btnNext = container.querySelector('[data-uniq-testimonial-next-button]');
    
    if (!track || cards.length === 0) return;

    let currentIndex = 0;
    const gap = 24;

    function getItemsPerView() {
        const w = window.innerWidth;
        if (w >= 900) return 3;
        if (w >= 600) return 2;
        return 1;
    }

    function updateCarousel() {
        const itemsPerView = getItemsPerView();
        const cardWidth = cards[0].offsetWidth;
        const moveAmount = (cardWidth + gap) * currentIndex;
        track.style.transform = `translateX(-${moveAmount}px)`;
        
        // Update Buttons
        if (btnPrev) btnPrev.disabled = currentIndex === 0;
        if (btnNext) btnNext.disabled = currentIndex >= (cards.length - itemsPerView);
    }

    if (btnNext) {
        btnNext.addEventListener('click', () => {
            const itemsPerView = getItemsPerView();
            if (currentIndex < cards.length - itemsPerView) {
                currentIndex++;
                updateCarousel();
            }
        });
    }

    if (btnPrev) {
        btnPrev.addEventListener('click', () => {
            if (currentIndex > 0) {
                currentIndex--;
                updateCarousel();
            }
        });
    }

    window.addEventListener('resize', updateCarousel);
    // Initial calculation
    setTimeout(updateCarousel, 100); 
});

  } catch(e) { console.error(e); }
})();
})();
